import React from 'react';
import Button from '../ui/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useFavorites } from '../../context/FavoritesContext';
import ImageCardDetails from '../ImageCardDetails/ImageCardDetails';
import VideoCardDetails from '../VideoCard/VideoCardDetails';

const Favorites = () => {
    const { favorites } = useFavorites();

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="text-center mb-8">
                <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 dark:text-white">
                    Your <span className="text-rose-500">favorites</span>
                </h1>
                <p className="text-gray-500 dark:text-gray-400 mt-2">
                    Saved on this device.
                </p>
            </div>

            {favorites.length === 0 ? (
                <div className="flex flex-col items-center justify-center text-center mt-16 text-gray-400 dark:text-gray-500">
                    <FontAwesomeIcon icon={faHeart} className="text-6xl mb-4" />
                    <h2 className="text-2xl font-bold">No favorites yet</h2>
                    <p className="mt-1 mb-6">Tap the heart on any photo or video to save it here.</p>
                    <Button to="/photos" size="lg">
                        Browse photos <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                </div>
            ) : (
                <div className="grid sm:grid-cols-2 md:grid-cols-3 grid-cols-1 gap-6 animate-fade-in">
                    {favorites.map((fav) =>
                        fav.kind === 'video' ? (
                            <VideoCardDetails key={`video-${fav.id}`} video={fav.item} />
                        ) : (
                            <ImageCardDetails key={`image-${fav.id}`} image={fav.item} />
                        )
                    )}
                </div>
            )}
        </div>
    );
};

export default Favorites;
